'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var XCircleIcon = function XCircleIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === undefined ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['color', 'size', 'filled', 'className', 'children']);

  var classes = 'calcite-icon';
  if (className) classes += ' ' + className;

  if (size <= 16) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 16 16',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M8 .15A7.85 7.85 0 1 0 15.85 8 7.85 7.85 0 0 0 8 .15zm4.95 11.386l-1.414 1.414L8 9.414 4.464 12.95 3.05 11.536 6.586 8 3.05 4.464 4.464 3.05 8 6.586l3.536-3.536 1.414 1.414L9.414 8z'
    }) : _react2.default.createElement('path', {
      d: 'M12.803 2.197a7.5 7.5 0 1 0 0 10.606 7.5 7.5 0 0 0 0-10.606zm-.636 9.97a6.6 6.6 0 1 1 0-9.334 6.608 6.608 0 0 1 0 9.334zM8.207 7.5l2.829 2.828-.708.708L7.5 8.207l-2.828 2.829-.708-.708L6.793 7.5 3.964 4.672l.708-.708L7.5 6.793l2.828-2.829.708.708z'
    }));
  }

  if (size <= 24) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 24 24',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M19.632 3.368a11.5 11.5 0 1 0 0 16.264 11.5 11.5 0 0 0 0-16.264zM18.57 16.45l-2.12 2.12-4.95-4.95-4.95 4.95-2.12-2.12 4.95-4.95-4.95-4.95 2.12-2.12 4.95 4.95 4.95-4.95 2.12 2.12-4.95 4.95z'
    }) : _react2.default.createElement('path', {
      d: 'M16.45 7.257L12.207 11.5l4.243 4.243-.707.707-4.243-4.243-4.243 4.243-.707-.707 4.243-4.243L6.55 7.257l.707-.707 4.243 4.243 4.243-4.243zM22 11.5A10.5 10.5 0 1 1 11.5 1 10.497 10.497 0 0 1 22 11.5zm-.9 0a9.6 9.6 0 1 0-9.6 9.6 9.61 9.61 0 0 0 9.6-9.6z'
    }));
  }

  return _react2.default.createElement('svg', _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: '0 0 32 32',
    className: classes
  }), filled ? _react2.default.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm9.192 20.364l-2.828 2.828L16 18.828l-6.364 6.364-2.828-2.828L13.172 16 6.808 9.636l2.828-2.828L16 13.172l6.364-6.364 2.828 2.828L18.828 16z'
  }) : _react2.default.createElement('path', {
    d: 'M25.753 5.247a14.5 14.5 0 1 0 0 20.506 14.5 14.5 0 0 0 0-20.506zm-.636 19.87a13.6 13.6 0 1 1 0-19.234 13.6 13.6 0 0 1 0 19.234zM21.864 9.843L16.207 15.5l5.657 5.657-.707.707-5.657-5.657-5.657 5.657-.707-.707 5.657-5.657-5.657-5.657.707-.707 5.657 5.657 5.657-5.657z'
  }));
};

exports.default = XCircleIcon;